import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Cnpros',
    data () {
        return {
            admin:{},
            cnpros: {},
            cnpro: {},
            viewFlag: "",
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.cnpro = attr2;
            }
        },
        requests(req){
            if(req == "delete"){ this.deleteRequest = true;}
            if(req == "edit"){ this.editRequest = true;}
            if(req == "reset"){ this.editRequest = false; this.deleteRequest = false;}
        },
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getCnpros() {
            service.getAllCnpros(this).then(data => {
               if(data.body.status == 200) {
                    this.cnpros = data.body.data;
                 }
            })
        },

        approveCnpro(cnpro) {
            service.approveCnpro(this, cnpro, this.cnpro).then(data => {
               if(data.body.status == 200) {
                        toastr.success("Approved!", "Success!");
                        this.cnpro.cnpro_status_id = 13;
                        this.cnpro.cnpro_status = "Approved";
                    }else {
                        toastr.error('Sorry, could not approve', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
        },

        //edit listing
        editListing() {
            service.adminEditCnpros(this, this.cnpro.cnpro_id, this.cnpro).then(data => {
               if(data.body.status == 200) {
                    toastr.success('Updated', 'Warning!');
                    this.editRequest = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //delete listing
        deleteListing() {
            service.adminDeleteCnpros(this, this.cnpro.cnpro_id).then(data => {
               if(data.body.status == 200) {
                    toastr.success('Removed', 'Warning!');
                    location.reload(true);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //get all saved listing
        getMoney(id) {
           service.getMoney(this, id).then(data => {
               if(data.body.status == 200) {
                    this.money = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

                 //uploads
        onFileChange(e, data, type) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', data);
                formData.append('data_type', type);   //image or idcard
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == 'cnpros'){
                            this.cnpro.cnpro_image = data.body.data;
                        }
                        if(type == 'cnpros_id_card'){
                            this.cnpro.cnpro_identity_card = data.body.data;
                        }
                        
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },

        
    },
    created: function(){
        this.preset();
        this.getCnpros();
    }
}


// WEBPACK FOOTER //
// ./src/components/Cnpros/script.js